import { __rest } from "tslib";
import * as React from 'react';
import { CoreTooltip } from '../internal/WixUiCoreComponents/components/CoreTooltip';
import { getArrowByPlacement } from './Arrows';
import { st, classes } from './Tooltip.cssVars.st.css';
import { TooltipSkin } from './types';
function customArrow(placement, arrowProps) {
    const ArrowSvg = getArrowByPlacement(placement);
    return (React.createElement("div", Object.assign({ className: classes.tpaArrow }, arrowProps),
        React.createElement(ArrowSvg, null)));
}
class Tooltip extends React.Component {
    render() {
        const _a = this.props, { className } = _a, rest = __rest(_a, ["className"]);
        return (React.createElement(CoreTooltip, Object.assign({ className: st(classes.root, { skin: this.props.skin }, className), timeout: { enter: 120, exit: 80 }, customArrow: customArrow }, rest)));
    }
}
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
    skin: TooltipSkin.Standard,
    maxWidth: 240,
};
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map